// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2r5P4","col":"styles_col__237Oy","fulfillmentStatus":"styles_fulfillmentStatus__1U4iJ","emailCol":"styles_emailCol__Gcjy1"};